<template>
  <div class="leak-content-table-cell">
    <div
      class="leak-content-table-cell__content"
      v-if='contentValue.length'
    >
      <span class='leak-content-table-cell__content__show-leak-btn' @click='showLeakContent'> {{ $t('show.leak.key.label') }} </span>
    </div>
    <div v-else>
      <span class="material-icons-outlined empty">
        remove
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LeakContentTableCell',
  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      show: false,
    };
  },
  computed: {
    contentValue() {
      return !this.item[this.column.field].length ? '' : '******';
    },
  },
  methods: {
    showLeakContent() {
      this.$emit('showLeakContentPopup', { item: this.item });
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@/assets/styles/design-system';
.leak-content-table-cell {
  z-index: 2;
  &__content {
    &__show-leak-btn {
      color: var(--brand-primary);
      font-family: $font-family-regular;
      font-size: rem(14);
      letter-spacing: 0;
      &:hover {
        cursor: pointer;
      }
    }
  }
}
</style>
